import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ThankYou: React.FC = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';

    return (
        <div className="min-h-[70vh] flex items-center justify-center bg-neutral-50 px-4 py-16" dir={isRTL ? 'rtl' : 'ltr'}>
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="max-w-2xl w-full bg-white rounded-3xl shadow-xl p-8 md:p-12 text-center relative overflow-hidden"
            >
                {/* Decorative background elements */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full -translate-y-16 translate-x-16" />
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-secondary/5 rounded-full translate-y-12 -translate-x-12" />

                <div className="relative">
                    <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-8">
                        <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>

                    <h1 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6 font-primary">
                        {t('thankYou.title')}
                    </h1>

                    <p className="text-lg text-neutral-600 mb-10 leading-relaxed max-w-md mx-auto">
                        {t('thankYou.message')}
                    </p>

                    <Link
                        to="/"
                        className="inline-flex items-center justify-center px-8 py-4 bg-gradient-primary text-white font-bold rounded-full shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/30 hover:-translate-y-1 transition-all duration-300 min-w-[240px]"
                    >
                        {t('thankYou.backHome')}
                        <svg
                            className={`w-5 h-5 ${isRTL ? 'mr-2 rotate-180' : 'ml-2'}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                    </Link>
                </div>
            </motion.div>
        </div>
    );
};

export default ThankYou;
